import { useSelector } from 'react-redux';

const PayGateLogos = () => {
  const settings = useSelector((state) => state.setting);
  if (settings.data?.payment?.gateway !== 'PayGateHosted') {
    return null;
  }

  return (
    <footer className="footer">
      <div className="content-wrapper">
        <div className="footer__payment-logos">
          <img
            src="/assets/images/payment-logos.png"
            alt="DPO Pay Gate Visa Mastercard Verified by VISA MasterCard SecureCode"
          />
        </div>
      </div>
    </footer>
  );
};

export default PayGateLogos;
